import OnlyHost from 'components/guards/OnlyHost';
import * as React from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { fetchGraphQL } from 'services/graphql/GraphQL';

interface IBarProps {
    ticketBank: any[];
    promoters: any;
    eventId: string;
}
class PromoterLeaderboard extends React.Component<IBarProps> {

    public state = {
        team1: [
            '5ef2351a02b3881017c6d279',
            '5ef2351a02b3881017c6d27a',
            '5ef20e3165246d463886c51a',
            '5ef20e3165246d463886c519',
            '5ef1d4f865246d463886ad8b',
            '5ef1d4f865246d463886ad8a',
            '5ef1d4f865246d463886ad89',
            '5ef1d4f865246d463886ad88',
            '5ef1d4f865246d463886ad87',
            '5ef1a3fdf4795e6eac6540ef'
        ],
        team3: [
            '5ef9776a10d4fe241a418bdc'
        ],
        // team2: [
        //     '5d82e6b5767f536f7c7e04b7',
        //     '5d82e8a1767f536f7c7e210f',
        //     '5d9e9342224c4873cb09eae3',
        //     '5da96ea4649d850c525054f7',
        //     '5dd6043608fa2f0c8add9ca3',
        //     '5dd61b2a08fa2f0c8ade11a5',
        //     '5ede952cda4c01753fb5e025',
        //     '5ede9e47da4c01753fb6411e',
        //     '5ef22f7b02b3881017c69064',
        //     '5ef22f7b02b3881017c69065',
        //     '5d633fbe4105f5165db03b9a'
        // ],
        filterStatus: 'Tickets Sold',
        filterDropdownOpen: false,
        tickets: [{
            promoterId: '',
            totalPrice: 0,
            totalCount: 0,
            status: '',
            ticketComponents: [{ checkedIn: 0 }],
        }],
        loading: true,
        urlObject: {
            code: '',
            customSubdomain: '',
            teamMap: [{
                userId: '',
                index: '',
                referralLinkViews: 0,
                name: '',
                email: ''
            }]
        }
    }

    constructor(props) {
        super(props)
        this.handleFilter = this.handleFilter.bind(this)
        this.toggleFilter = this.toggleFilter.bind(this);
    }

    public componentDidMount() {
        //  console.log(this.props.ticketBank)
        fetchGraphQL(`
        query {
            ticket {
                getAllByEventIdAsString(eventId:"${this.props.eventId}")
            }
        }
        `).then(res => {
            fetchGraphQL(`
            query {
                url {
                    get(eventId:"${this.props.eventId}") {
                        code
                        customSubdomain
                        teamMap {
                            userId
                            index
                            referralLinkViews
                            name
                            email
                        }
                    }
                }
            }
            `).then(res2 => {
                this.setState({
                    tickets: JSON.parse(res.ticket.getAllByEventIdAsString),
                    loading: false,
                    urlObject: res2.url.get
                })
            })
        })
    }

    public handleFilter(obj: string) {
        this.setState({ filterStatus: obj })
    }

    public toggleFilter() {
        this.setState(
            (oldState: any) => {
                return {
                    loading: true
                };
            },
            () => {
                this.setState(
                    (oldState: any) => {
                        return {
                            filterDropdownOpen: !this.state.filterDropdownOpen
                        };
                    },
                    () => {
                        this.setState({ loading: false })
                    })
            })
    }

    public render() {

        if (this.state.loading) {
            return null;
        }

        const sortable: any[] = [];

        switch (this.state.filterStatus) {
            case 'Revenue': {
                const revenueMap: any = {}
                this.state.tickets.map((item) => {
                    if (item.promoterId && (item.status === 'bought' || item.status === 'partiallyCheckedIn' || item.status === 'checkedIn')) {
                        if (revenueMap[item.promoterId] !== undefined) {
                            revenueMap[item.promoterId] += (Number(item.totalPrice) / 100)
                        } else {
                            revenueMap[item.promoterId] = (Number(item.totalPrice) / 100)
                        }
                    }
                })
                for (const promoterId in revenueMap) {
                    if (true) {
                        sortable.push([promoterId, revenueMap[promoterId]]);
                    }
                }

                sortable.sort((a, b) => {
                    return b[1] - a[1]
                })
                break;
            }

            case 'Tickets Sold': {
                const revenueMap: any = {}
                this.state.tickets.map((item) => {
                    if (item.promoterId && (item.status === 'bought' || item.status === 'partiallyCheckedIn' || item.status === 'checkedIn')) {
                        if (revenueMap[item.promoterId] !== undefined) {
                            revenueMap[item.promoterId] += (item.totalCount)
                        } else {
                            revenueMap[item.promoterId] = (item.totalCount)
                        }
                    }
                })
                for (const promoterId in revenueMap) {
                    if (true) {
                        sortable.push([promoterId, revenueMap[promoterId]]);
                    }
                }
                sortable.sort((a, b) => {
                    return b[1] - a[1]
                })
                break;
            }
            case 'Tickets Activated': {
                const revenueMap: any = {}
                this.state.tickets.map((item) => {
                    if (item.promoterId && item.status === 'activated') {
                        if (revenueMap[item.promoterId] !== undefined) {
                            revenueMap[item.promoterId] += Number(item.totalCount)
                        } else {
                            revenueMap[item.promoterId] = Number(item.totalCount)
                        }
                    }
                })

                for (const promoterId in revenueMap) {
                    if (true) {
                        sortable.push([promoterId, revenueMap[promoterId]]);
                    }
                }

                sortable.sort((a, b) => {
                    return b[1] - a[1]
                })
                break;
            }

            case 'Referral Link Views': {
                this.state.urlObject.teamMap.map((promoter: any) => {
                    if (
                        !promoter.referralLinkViews || promoter.referralLinkViews === 0 || promoter.referralLinkViews === '0'
                    ) {
                        return;
                    } else {
                        sortable.push([promoter.userId, promoter.referralLinkViews]);
                    }
                })
                sortable.sort((a, b) => {
                    return b[1] - a[1]
                })
                break;
            }

            case 'Tickets Checked-in': {
                const revenueMap: any = {}
                this.state.tickets.map((item) => {
                    if (item.promoterId && (item.status === 'partiallyCheckedIn' || item.status === 'checkedIn')) {
                        let checkedInCount = 0
                        item.ticketComponents.map(i => {
                            checkedInCount += (i.checkedIn ? Number(i.checkedIn) : 0);
                        })
                        if (revenueMap[item.promoterId] !== undefined) {
                            revenueMap[item.promoterId] += checkedInCount
                        } else {
                            revenueMap[item.promoterId] = checkedInCount
                        }
                    }
                })
                for (const promoterId in revenueMap) {
                    if (true) {
                        sortable.push([promoterId, revenueMap[promoterId]]);
                    }
                }
                sortable.sort((a, b) => {
                    return b[1] - a[1]
                })
                break;
            };

            default: {

                const revenueMap: any = {}
                this.state.tickets.map((item) => {
                    if (item.promoterId && (item.status === 'bought' || item.status === 'partiallyCheckedIn' || item.status === 'checkedIn')) {
                        if (revenueMap[item.promoterId] !== undefined) {
                            revenueMap[item.promoterId] += Number(item.totalCount)
                        } else {
                            revenueMap[item.promoterId] = Number(item.totalCount)
                        }
                    }
                })
                for (const promoterId in revenueMap) {
                    if (true) {
                        sortable.push([promoterId, revenueMap[promoterId]]);
                    }
                }
                sortable.sort((a, b) => {
                    return b[1] - a[1]
                })
                break;
            }

        }

        // console.log(sortable)
        let rank1 = 0;
        let rank2 = 0;
        let rank3 = 0;

        return (
            <div>
                <div style={{ textAlign: 'center', paddingRight: '5%', paddingLeft: '5%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ maxWidth: '180px' }}>
                        <Dropdown isOpen={this.state.filterDropdownOpen} toggle={this.toggleFilter} className="new-button-white-3" onClick={e => this.toggleFilter()} style={{ cursor: 'pointer' }}>
                            <DropdownToggle
                                tag="span"
                                onClick={e => this.toggleFilter()}
                                data-toggle="dropdown"
                                aria-expanded={this.state.filterDropdownOpen}
                                caret={true}
                            >
                                {this.state.filterStatus === "Tickets Activated" ? ('Rank By Offers Created').toUpperCase() : ('Rank By ' + this.state.filterStatus).toUpperCase()}
                            </DropdownToggle>
                            <DropdownMenu style={{ borderRadius: '30px' }}>
                                <DropdownItem header={true}>RANK BY</DropdownItem>
                                <OnlyHost eventId={this.props.eventId}>
                                    <DropdownItem onClick={e => this.handleFilter("Revenue")}>REVENUE</DropdownItem>
                                </OnlyHost>
                                <DropdownItem onClick={e => this.handleFilter("Tickets Sold")}>TICKETS SOLD</DropdownItem>
                                {/* <DropdownItem onClick={e => this.handleFilter("Total Allocated")}>TOTAL ALLOCATED</DropdownItem>
                                 */}
                                <DropdownItem onClick={e => this.handleFilter("Tickets Activated")}>OFFERS CREATED</DropdownItem>
                                <DropdownItem onClick={e => this.handleFilter("Tickets Checked-in")}>TICKETS CHECKED-IN</DropdownItem>
                                {/* <DropdownItem onClick={e => this.handleFilter("Referral Link")}>REFERRAL LINKS</DropdownItem> */}
                                <DropdownItem onClick={e => this.handleFilter('Referral Link Views')}>REFERRAL LINK VIEWS</DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
                <p><br /></p>
                <div style={{
                    overflowX: "scroll"
                }}>
                    {
                        this.props.eventId === '5eec25888f4c8f13e0db778c' ?
                            <h6 style={{ width: '100%', textAlign: 'center' }}>Moon Fazed</h6>
                            : null
                    }
                    <table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
                        <thead style={{ width: '95%', height: 'auto' }}>
                            <tr>
                                <th style={{ textAlign: 'center' }}>Rank</th>
                                <th style={{ textAlign: 'center' }}>Name</th>
                                <th style={{ textAlign: 'center' }}>
                                    {this.state.filterStatus === "Tickets Activated" ? "OFFERS CREATED" : this.state.filterStatus.toUpperCase()}
                                </th>
                            </tr>
                        </thead>
                    </table>
                    <div style={{ maxHeight: '400px' }}>
                        <table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
                            <tbody>
                                {sortable.length > 0 ? (
                                    sortable.map((item, index) => {
                                        const user = this.state.urlObject.teamMap.find((i: any) =>
                                            i.userId.trim() === item[0]
                                        );

                                        if (user === undefined || user == null) {
                                            return;
                                        }

                                        if (this.props.eventId === '5eec25888f4c8f13e0db778c' && !this.state.team1.includes(user.userId)) {
                                            return;
                                        }

                                        rank1 = rank1 + 1;

                                        console.log('RENDER' + ' ' + rank1.toString())
                                        // else
                                        return (
                                            <tr key={"promoter-"}>
                                                <td data-label="Rank" style={{ textAlign: 'center' }}>
                                                    {rank1 - 1 === 0 ? <span style={{ color: '#d4af37' }}>♛&nbsp;{rank1}</span>
                                                        : (rank1 - 1 === 1 ? <span style={{ color: '#c0c0c0' }}>♛&nbsp;{rank1}</span>
                                                            : (rank1 - 1 === 2 ? <span style={{ color: '#cd7f32' }}>♛&nbsp;{rank1}</span> : rank1))}
                                                </td>
                                                <td data-label="Name" className="sexyBlack" style={{ textAlign: 'center' }}>
                                                    {user.name || ''}
                                                </td>
                                                <td data-label="Filter" style={{ textAlign: 'center' }} >
                                                    {this.state.filterStatus === 'Revenue' ? '$' + (item[1]).toFixed(2) : item[1]}
                                                </td>
                                            </tr>
                                        );

                                    })
                                ) : (
                                        <tr>
                                            <td colSpan={3} className="text-center">
                                                No data to display.
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    this.props.eventId === '5eec25888f4c8f13e0db778c' ?
                        <div>
                            <p><br /></p>
                            <div style={{
                                overflowX: "scroll"
                            }}>
                                {
                                    this.props.eventId === '5eec25888f4c8f13e0db778c' ?
                                        <h6 style={{ width: '100%', textAlign: 'center' }}>Malum Geminos</h6>
                                        : null
                                }
                                <table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
                                    <thead style={{ width: '95%', height: 'auto' }}>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>Rank</th>
                                            <th style={{ textAlign: 'center' }}>Name</th>
                                            <th style={{ textAlign: 'center' }}>{this.state.filterStatus === "Tickets Activated" ? "OFFERS CREATED" : this.state.filterStatus.toUpperCase()}</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div style={{ maxHeight: '400px' }}>
                                    <table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
                                        <tbody>
                                            {sortable.length > 0 ? (
                                                sortable.map((item, index) => {
                                                    const user = this.state.urlObject.teamMap.find((i: any) =>
                                                        i.userId.trim() === item[0]
                                                    );
                                                    if (user === undefined || user === null) {
                                                        return;
                                                    }
                                                    if (this.props.eventId === '5eec25888f4c8f13e0db778c' && this.state.team1.includes(user.userId)) {
                                                        return;
                                                    }

                                                    rank2 = rank2 + 1;
                                                    // else
                                                    return (
                                                        <tr key={"promoter-" + rank2}>
                                                            <td data-label="Rank" style={{ textAlign: 'center' }}>
                                                                {rank2 - 1 === 0 ? <span style={{ color: '#d4af37' }}>♛&nbsp;{rank2}</span>
                                                                    : (rank2 - 1 === 1 ? <span style={{ color: '#c0c0c0' }}>♛&nbsp;{rank2}</span>
                                                                        : (rank2 - 1 === 2 ? <span style={{ color: '#cd7f32' }}>♛&nbsp;{rank2}</span> : rank2))}
                                                            </td>
                                                            <td data-label="Name" className="sexyBlack" style={{ textAlign: 'center' }}>
                                                                {user.name || ''}
                                                            </td>
                                                            <td data-label="Filter" style={{ textAlign: 'center' }} >
                                                                {this.state.filterStatus === 'Revenue' ? '$' + (item[1]).toFixed(2) : item[1]}
                                                            </td>
                                                        </tr>
                                                    );

                                                })
                                            ) : (
                                                    <tr>
                                                        <td colSpan={3} className="text-center">
                                                            No data to display.
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        : null
                }
                {
                    this.props.eventId === '5eec25888f4c8f13e0db778c' ?
                        <div>
                            <p><br /></p>
                            <div style={{
                                overflowX: "scroll"
                            }}>
                                {
                                    this.props.eventId === '5eec25888f4c8f13e0db778c' ?
                                        <h6 style={{ width: '100%', textAlign: 'center' }}>CHURCH OF BASS LV</h6>
                                        : null
                                }
                                <table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
                                    <thead style={{ width: '95%', height: 'auto' }}>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>Rank</th>
                                            <th style={{ textAlign: 'center' }}>Name</th>
                                            <th style={{ textAlign: 'center' }}>{this.state.filterStatus === "Tickets Activated" ? "OFFERS CREATED" : this.state.filterStatus.toUpperCase()}</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div style={{ maxHeight: '400px' }}>
                                    <table className='table-responsive--base' style={{ minWidth: '300px', overflowX: 'scroll' }}>
                                        <tbody>
                                            {sortable.length > 0 ? (
                                                sortable.map((item, index) => {
                                                    const user = this.state.urlObject.teamMap.find((i: any) =>
                                                        i.userId.trim() === item[0]
                                                    );
                                                    if (user === undefined || user === null) {
                                                        return;
                                                    }
                                                    if (!this.state.team3.includes(user.userId)) {
                                                        return;
                                                    }
                                                    rank3 = rank3 + 1;
                                                    // else
                                                    return (
                                                        <tr key={"promoter-" + rank3}>
                                                            <td data-label="Rank" style={{ textAlign: 'center' }}>
                                                                {rank3 - 1 === 0 ? <span style={{ color: '#d4af37' }}>♛&nbsp;{rank3}</span>
                                                                    : (rank3 - 1 === 1 ? <span style={{ color: '#c0c0c0' }}>♛&nbsp;{rank3}</span>
                                                                        : (rank3 - 1 === 2 ? <span style={{ color: '#cd7f32' }}>♛&nbsp;{rank3}</span> : rank3))}
                                                            </td>
                                                            <td data-label="Name" className="sexyBlack" style={{ textAlign: 'center' }}>
                                                                {user.name || ''}
                                                            </td>
                                                            <td data-label="Filter" style={{ textAlign: 'center' }} >
                                                                {this.state.filterStatus === 'Revenue' ? '$' + (item[1]).toFixed(2) : item[1]}
                                                            </td>
                                                        </tr>
                                                    );

                                                })
                                            ) : (
                                                    <tr>
                                                        <td colSpan={3} className="text-center">
                                                            No data to display.
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        : null
                }
            </div>
        )
    }
}

export default PromoterLeaderboard;



// WEBPACK FOOTER //
// ./src/pages/manage/events/detail/PromoterLeaderboard.tsx